import { colorsPalettes } from "@similarweb/styles";
import { Button, Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { generateAutomationName } from "app/pages/activation/helpers/generateAutomationName";

export interface IEmptyStateOverlayContentProps {
    messageKey: string;
    ctaKey: string;
    tooltipContent?: string;
    isDisabled?: boolean;
    onClick?: (e?: React.MouseEvent) => Promise<void>;
}

export const EmptyStateOverlayContent = ({
    messageKey,
    ctaKey,
    tooltipContent,
    isDisabled,
    onClick,
}: IEmptyStateOverlayContentProps) => {
    const button = (
        <Button
            type="flat"
            isDisabled={isDisabled}
            data-automation={generateAutomationName("home", ["share", "data", "empty", "state", "cta"])}
        >
            {translate(ctaKey)}
        </Button>
    );

    return (
        <Stack
            gap="8"
            alignItems="center"
            data-automation={generateAutomationName("home", ["share", "data", "empty", "state", "overlay"])}
            onClick={onClick}
        >
            <Text
                fontVariant="tab"
                color={colorsPalettes.carbon[500]}
                textAlign="center"
                maxWidth="280px"
                data-automation={generateAutomationName("home", ["share", "data", "empty", "state", "message"])}
            >
                {translate(messageKey)}
            </Text>

            {tooltipContent ? (
                <Tooltip
                    content={translate(tooltipContent)}
                    enabled
                    placement="bottom"
                >
                    <div>{button}</div>
                </Tooltip>
            ) : ctaKey ? (
                button
            ) : null}
        </Stack>
    );
};
